import { TextInput, type TextInputProps } from '@mantine/core';
import { useEffect, useState } from 'react';
import { formatDuration, parseDuration, type DurationFormat } from '@/lib/format';

interface Props extends Omit<TextInputProps, 'value' | 'onChange'> {
  seconds: number | null;
  onCommit: (seconds: number) => void;
  format?: DurationFormat;
}

/** Eingabe einer Dauer mit flexibler Schreibweise; übernimmt bei Blur/Enter. */
export function DurationInput({ seconds, onCommit, format = 'FULL', ...rest }: Props) {
  const display = seconds == null ? '' : formatDuration(seconds, format === 'DECIMAL' ? 'FULL' : format);
  const [text, setText] = useState(display);
  useEffect(() => setText(display), [display]);

  const commit = () => {
    const parsed = parseDuration(text);
    if (parsed == null) {
      setText(display);
    } else if (parsed !== seconds) {
      onCommit(parsed);
    } else {
      setText(display);
    }
  };

  return (
    <TextInput
      value={text}
      onChange={(e) => setText(e.currentTarget.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          (e.target as HTMLInputElement).blur();
        }
        if (e.key === 'Escape') {
          setText(display);
        }
      }}
      onFocus={(e) => e.currentTarget.select()}
      {...rest}
    />
  );
}
